import { Box, Grid } from "@material-ui/core"
import NCText from "../../shared/NCText"
import { useGetFeedbackList, useGetPayrollList } from "../../services/queries"
import { useState } from "react"
import NCTable from "../../shared/table/NCTable"
import FeedbackCard from "../../components/feedback/FeedbackCard"
import { TABLE_CONFIG } from "../../libs/config"
import { loggedInUser } from "../../libs/utils"
import NotificationAlert from "../../components/notification/NotificationAlert"
import { useTranslation } from "react-i18next"

const FeedbackList = () => {
  const { t } = useTranslation()
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(TABLE_CONFIG.PAGE_SIZE)
  const user = loggedInUser()

  const ACCESS_ROLES = {
    SUPER_ADMIN: 1,
    ADMIN: 2,
    SUB_ADMIN: 3
  }

  const Tabs = [
    {
      name: t("feedback.tabs.all_feedback"),
      role: [ACCESS_ROLES.SUPER_ADMIN, ACCESS_ROLES.ADMIN, ACCESS_ROLES.SUB_ADMIN],
      user_type: null
    },
    {
      name: t("feedback.tabs.admin"),
      role: [ACCESS_ROLES.SUPER_ADMIN],
      user_type: [2]
    },
    {
      name: t("feedback.tabs.subadmin"),
      role: [ACCESS_ROLES.SUPER_ADMIN, ACCESS_ROLES.ADMIN],
      user_type: [3]
    },
    {
      name: t("feedback.tabs.driver"),
      role: [ACCESS_ROLES.SUPER_ADMIN],
      user_type: [6, 10]
    },
    {
      name: t("feedback.tabs.client"),
      role: [ACCESS_ROLES.SUPER_ADMIN],
      user_type: [8, 9]
    },
    {
      name: t("feedback.tabs.guardian"),
      role: [ACCESS_ROLES.SUPER_ADMIN],
      user_type: [7]
    },
    {
      name: t("feedback.tabs.payroll"),
      role: [ACCESS_ROLES.SUPER_ADMIN],
      user_type: [7]
    }
  ]

  // default tab = first available one for the logged-in user
  const [selectedTab, setSelectedTab] = useState(
    Tabs.find(tab => tab.role.includes(user.user_type)) || Tabs[0]
  )

  const getUserType = () => {
    const userType = selectedTab?.user_type
    if (!userType) return null
    if (Array.isArray(userType)) return userType.join(",") // ✅ 8,9
    return userType
  }

  const { isLoading, data } = useGetFeedbackList(
    page,
    null,
    pageSize,
    { created_user_type: getUserType() },
    { enabled: selectedTab?.name !== t("feedback.tabs.payroll") }
  )

  const { isLoading: payrollLoading, data: payrollData } = useGetPayrollList(
    page,
    null,
    pageSize,
    {},
    { enabled: selectedTab?.name === t("feedback.tabs.payroll") }
  )

  const { next, previous, total_pages, results } =
    selectedTab?.name !== t("feedback.tabs.payroll")
      ? data?.data?.data || {}
      : payrollData?.data?.data || {}

  const onNext = () => setPage(prev => (next ? prev + 1 : prev))
  const onPrev = () => setPage(prev => (previous ? prev - 1 : prev))

  const columns = [
    {
      Header: "",
      id: "feedback",
      disableSortBy: true,
      accessor: cell => cell,
      Cell: ({ row }) => (
        <FeedbackCard
          detail={row?.values?.feedback}
          index={row.index}
          selectedTab={selectedTab}
        />
      )
    }
  ]

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box pb={"60px"}>
          <Grid container justifyContent="space-between">
            <Grid item xs={6}>
              <NCText variant={"h4"}>{t("feedback.heading")}</NCText>
            </Grid>
            <Grid item xs={6}>
              <Box display={"flex"} justifyContent={"flex-end"}>
                <NotificationAlert />
              </Box>
            </Grid>

            <Grid item xs={12} className="feedback-container">
              <Box>
                {/* Tabs */}
                <Box
                  display={"flex"}
                  gridGap={"10px"}
                  pt={"20px"}
                  borderBottom={"1px solid #E5E7EB"}
                >
                  {Tabs.filter(tab => tab.role.includes(user.user_type)).map(tab => (
                    <Box
                      key={tab.name}
                      p={"10px"}
                      borderBottom={
                        selectedTab?.name === tab.name
                          ? "1px solid #1EAAC4"
                          : "1px solid transparent"
                      }
                      onClick={() => {
                        setPage(1)
                        setSelectedTab(tab)
                      }}
                      className={"cursor-pointer"}
                    >
                      <NCText
                        className="fw-bold"
                        color={
                          selectedTab?.name === tab.name ? "primary" : "textSecondary"
                        }
                      >
                        {tab.name}
                      </NCText>
                    </Box>
                  ))}
                </Box>

                {/* Table */}
                <NCTable
                  columns={columns}
                  data={results || []}
                  page={page}
                  onNext={onNext}
                  onPrev={onPrev}
                  pageCount={total_pages}
                  gotoPage={setPage}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  isLoading={isLoading || payrollLoading}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  )
}

export default FeedbackList
